const CLASS_CHECKED = 'is__checked'
const CLASS_HAS_IMAGE_WITH_CAPTION = 'has__imageWithCaption'
const CLASS_WITHOUT_HOVER = 'without__hover'

var Answer = function($el, question) {
  this.$el = $el
  this.$image = this.$el.find('.image')
  this.$caption = this.$el.find('.caption')
  this.$captionLink = this.$caption.find('a')
  this.$activeEl = this.hasImageWithCaption() ? this.$image.add(this.$caption) : this.$el

  this._question = question
  this._test = this._question._test
  this.id = this._question.id + '.' + this.$el.data('id')
  this.isCorrect = parseInt(this.$el.data('correct'), 10)

  if (this.isCorrect) this._question.counters.totalCorrect++

  this.bindHandleEvents()
  this.enableAnswerToggling()
  this.enableLinkInAnswer()
}

Answer.prototype.state = function() { return window.application.state }

Answer.prototype.handleAnswerClick = function(e) {
  e.preventDefault()
  e.stopPropagation()

  const hasText = !!(e.target.textContent.trim() || e.target.innerText.trim())
  const hasSelection = !!(window.getSelection().toString().length)

  if (hasText && hasSelection) return

  this.toggle()
}

Answer.prototype.bindHandleEvents = function() {
  this.handleAnswerClick = this.handleAnswerClick.bind(this)
}

Answer.prototype.enableAnswerToggling = function() {
  this.$activeEl.on('click', e => this.handleAnswerClick(e))
}

Answer.prototype.enableLinkInAnswer = function() {
  const $el = this.$el

  this.$captionLink
    .on('mouseenter', () => $el.toggleClass(CLASS_WITHOUT_HOVER))
    .on('mouseleave', () => $el.toggleClass(CLASS_WITHOUT_HOVER))
    .on('click', e => e.stopPropagation())
}

Answer.prototype.init = function() {
  this.state().on(`answer/check-${this.id}`, this.check.bind(this))
  this.state().on(`answer/uncheck-${this.id}`, this.uncheck.bind(this))
  this.state().on('answers/sync', this.sync.bind(this))

  if (this.state().getAnswers().includes(this.id)) {
    this.toggle()
  }
}

Answer.prototype.check = function() {
  if (this.isChecked) return

  this.isChecked = 1
  this.$el.addClass(CLASS_CHECKED)

  this.record()
  this._question.check(this.isChecked, this.isCorrect)
}

Answer.prototype.uncheck = function() {
  if (!this.isChecked) return

  this.isChecked = 0
  this.$el.removeClass(CLASS_CHECKED)

  this.record()
  this._question.check(this.isChecked, this.isCorrect)
}

Answer.prototype.sync = function(answers) {
  if (answers.includes(this.id) && !this.isChecked) {
    this.check()
  } else if (!answers.includes(this.id) && this.isChecked) {
    this.uncheck()
  }
}

Answer.prototype.toggle = function() {
  if (this.isChecked) {
    this.uncheck()
  } else {
    if (this._question.isRadio) this._question.uncheckOtherThan(this)

    this.check()
  }
}

Answer.prototype.lock = function() {
  this.$activeEl.off('click')
}

Answer.prototype.reset = function() {
  this.isChecked = 0
  this.$el.removeClass(CLASS_CHECKED)
  this.enableAnswerToggling()
}

Answer.prototype.record = function() {
  if (this.isChecked) {
    this.state().addAnswer(this.id)
  } else {
    this.state().removeAnswer(this.id)
  }
}

Answer.prototype.hasImageWithCaption = function() {
  return this.$el.hasClass(CLASS_HAS_IMAGE_WITH_CAPTION)
}

module.exports = Answer
